import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalErrorLogger from './components/GlobalErrorLogger';

// Добавляем обработчик для отлова ошибок до загрузки React
console.log('[STARTUP] Приложение начинает загрузку...');

try {
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    throw new Error('Root element not found! DOM элемент с id="root" отсутствует.');
  }

  console.log('[STARTUP] Root element найден, создаем React root...');
  const root = ReactDOM.createRoot(rootElement as HTMLElement);
  
  console.log('[STARTUP] Рендерим приложение...');
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
        <GlobalErrorLogger />
      </ErrorBoundary>
    </React.StrictMode>
  );
  
  console.log('[STARTUP] ✓ Приложение успешно запущено!');
} catch (error) {
  console.error('[STARTUP ERROR] Критическая ошибка при запуске:', error);
  
  // Показываем ошибку прямо в DOM, если React не смог загрузиться
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="
        min-height: 100vh;
        background-color: #1a1a1a;
        color: #fff;
        padding: 20px;
        font-family: system-ui, -apple-system, sans-serif;
      ">
        <div style="max-width: 800px; margin: 0 auto;">
          <div style="
            background-color: #dc2626;
            padding: 16px;
            border-radius: 8px;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            gap: 12px;
          ">
            <span style="font-size: 32px;">⚠️</span>
            <div>
              <h1 style="margin: 0; font-size: 20px; font-weight: bold;">
                Критическая ошибка загрузки
              </h1>
              <p style="margin: 4px 0 0 0; font-size: 14px; opacity: 0.9;">
                Приложение не смогло запуститься
              </p>
            </div>
          </div>
          
          <button onclick="window.location.reload()" style="
            background-color: #3b82f6;
            color: #fff;
            border: none;
            padding: 12px 24px;
            border-radius: 6px;
            cursor: pointer;
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 20px;
          ">
            🔄 Перезагрузить страницу
          </button>
          
          <div style="
            background-color: #2d2d2d;
            padding: 16px;
            border-radius: 8px;
            margin-bottom: 16px;
            border: 1px solid #404040;
          ">
            <h2 style="
              margin: 0 0 12px 0;
              font-size: 16px;
              color: #f87171;
            ">
              Ошибка:
            </h2>
            <pre style="
              margin: 0;
              white-space: pre-wrap;
              word-break: break-word;
              font-size: 13px;
              line-height: 1.5;
              color: #fca5a5;
              font-family: monospace;
            ">${error instanceof Error ? error.message : String(error)}</pre>
          </div>
          
          ${error instanceof Error && error.stack ? `
          <div style="
            background-color: #2d2d2d;
            padding: 16px;
            border-radius: 8px;
            border: 1px solid #404040;
          ">
            <h2 style="
              margin: 0 0 12px 0;
              font-size: 16px;
              color: #fbbf24;
            ">
              Stack Trace:
            </h2>
            <pre style="
              margin: 0;
              white-space: pre-wrap;
              word-break: break-word;
              font-size: 12px;
              line-height: 1.5;
              color: #d1d5db;
              max-height: 300px;
              overflow-y: auto;
              font-family: monospace;
            ">${error.stack}</pre>
          </div>
          ` : ''}
          
          <div style="
            margin-top: 24px;
            padding: 16px;
            background-color: #1e3a5f;
            border-radius: 8px;
            border: 1px solid #2563eb;
          ">
            <h3 style="
              margin: 0 0 8px 0;
              font-size: 14px;
              color: #93c5fd;
            ">
              💡 Что делать:
            </h3>
            <ul style="
              margin: 0;
              padding-left: 20px;
              font-size: 13px;
              line-height: 1.8;
              color: #bfdbfe;
            ">
              <li>Попробуйте перезагрузить страницу</li>
              <li>Очистите кэш браузера (Ctrl+Shift+Delete)</li>
              <li>Проверьте соединение с интернетом</li>
              <li>Убедитесь, что JavaScript включен в браузере</li>
              <li>Если проблема повторяется, сделайте скриншот и отправьте администратору</li>
            </ul>
          </div>
        </div>
      </div>
    `;
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
